import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import ProfileCard from './ProfileCard';
import SkillsCard from './SkillsCard';
import ExternalEmploymentCard from './ExternalEmploymentCard';
import WarningsCard from './WarningsCard';
import DocumentCompletenessCard from './DocumentCompletenessCard';
import AvailabilityCard from './AvailabilityCard';

// Composite vivier panel (plan 013 B2/B4). Reused by the Cleaner show "Vivier"
// tab and by the dedicated vivier Show. Everything is keyed on silae_id.
// WarningsCard self-hides for non RH/manager users.
// `showAvailability` adds the disponibilité editor (plan 014); only the
// dedicated vivier Show enables it — the cleaner fiche has its own dedicated
// "Disponibilités" tab, so we keep it off there to avoid a duplicate editor.
const VivierPanel = ({
  silaeId,
  sourceCleanerId,
  showDocuments,
  showAvailability,
}) => {
  return (
    <Grid container spacing={2}>
      <ProfileCard silaeId={silaeId} sourceCleanerId={sourceCleanerId} />
      <SkillsCard silaeId={silaeId} />
      <ExternalEmploymentCard silaeId={silaeId} />
      {showAvailability && (
        <AvailabilityCard silaeId={silaeId} sourceCleanerId={sourceCleanerId} />
      )}
      {showDocuments && (
        <DocumentCompletenessCard
          silaeId={silaeId}
          sourceCleanerId={sourceCleanerId}
        />
      )}
      <WarningsCard silaeId={silaeId} />
    </Grid>
  );
};

VivierPanel.propTypes = {
  silaeId: PropTypes.string,
  sourceCleanerId: PropTypes.string,
  showDocuments: PropTypes.bool,
  showAvailability: PropTypes.bool,
};

VivierPanel.defaultProps = {
  silaeId: '',
  sourceCleanerId: '',
  showDocuments: false,
  showAvailability: false,
};

export default VivierPanel;
